import React from "react"

import ConfirmModal from "./ConfirmModal"

export interface Props {
  cancelLabel?: string
  confirmLabel?: string
  isConfirmDisabled?: boolean
  isDisabled?: boolean
  isLoading?: boolean
  onClose: () => void
  onConfirm: () => void
  message: string | React.ReactNode
}

export interface ComponentProps extends Props {}

export default ConfirmModal
